export const FEATURE_FLAGS = [
  'FEATURE_EXTRACTION',
  'FEATURE_STORAGE_SPACE',
  'FEATURE_SECRETS_ADVANCED',
] as const

export type FeatureFlagName = (typeof FEATURE_FLAGS)[number]

export type FeatureFlagBindings = Partial<Record<FeatureFlagName, unknown>>

export interface FeatureProfile {
  extraction: boolean
  storageSpace: boolean
  secretsAdvanced: boolean
}

/** Product launch flags fail closed: only the exact string "true" enables behavior. */
export function isFeatureEnabled(value: unknown): boolean {
  return value === 'true'
}

export function getFeatureProfile(bindings: FeatureFlagBindings): FeatureProfile {
  return {
    extraction: isFeatureEnabled(bindings.FEATURE_EXTRACTION),
    storageSpace: isFeatureEnabled(bindings.FEATURE_STORAGE_SPACE),
    secretsAdvanced: isFeatureEnabled(bindings.FEATURE_SECRETS_ADVANCED),
  }
}
